

<div class="fluid-container">
  <div class="title-tab-step text-center">
    {{ 'Create Infection Control Plan' | translate }}
  </div>
  <!-- Plan Details Form -->
  <form class="master-form">
    <div class="row">

 
    <div class="mb-3 col-sm-4">
      <label for="planName" class="form-label">Plan Name</label>
      <input type="text" class="form-control" id="planName" [(ngModel)]="plan.name" name="planName">
    </div>
    <div class="mb-3 col-sm-4">
      <label for="planDescription" class="form-label">Plan Description</label>
      <textarea class="form-control" id="planDescription" rows="3" [(ngModel)]="plan.description"
        name="planDescription"></textarea>
    </div>

    <!-- Category Selection -->
    <div class="mb-3 col-sm-4">
      <label for="categories" class="form-label">Select Categories</label>
      <select class="form-select" id="categories" [(ngModel)]="plan.selectedCategory" name="categories">
        <option *ngFor="let category of categories" [ngValue]="category">{{ category.name }}</option>
      </select>
    </div>

    <!-- Subcategory and Interventions -->
    <div class="mb-3 col-sm-4">
      <label for="subcategories" class="form-label">Select Subcategories</label>
      <select class="form-select" id="subcategories" [(ngModel)]="plan.selectedSubcategory" name="subcategories">
        <option *ngFor="let subcategory of plan.selectedCategory?.subcategories" [ngValue]="subcategory">{{
          subcategory.name }}</option>
      </select>
    </div>

    <div class="mb-3 col-sm-4">
      <label for="interventions" class="form-label">Select Interventions</label>
      <div *ngFor="let intervention of plan.selectedSubcategory?.interventions" class="form-check">
        <input class="form-check-input" type="checkbox" [value]="intervention"
          (change)="toggleIntervention(intervention)">
        <label class="form-check-label">{{ intervention }}</label>
      </div>
    </div>

    <!-- Responsibility Assignment -->
    <div class="mb-3 col-sm-4">
      <label for="responsiblePerson" class="form-label">Assign Responsible Person</label>
      <input type="text" class="form-control" id="responsiblePerson" [(ngModel)]="plan.responsiblePerson"
        name="responsiblePerson">
    </div>

    <!-- Timeline and Schedule -->
    <div class="mb-3 col-sm-4">
      <label for="timeline" class="form-label">Set Timeline</label>
      <input type="date" class="form-control" id="timeline" [(ngModel)]="plan.timeline" name="timeline">
    </div>

    <!-- Progress Tracking -->
    <div class="mb-3 col-sm-4">
      <label for="progress" class="form-label">Track Progress</label>
      <input type="range" class="form-range" id="progress" [(ngModel)]="plan.progress" name="progress" min="0"
        max="100">
      <div class="progress">
        <div class="progress-bar" role="progressbar" [style.width.%]="plan.progress" aria-valuenow="plan.progress"
          aria-valuemin="0" aria-valuemax="100">{{ plan.progress }}%</div>
      </div>
    </div>
  </div>
    <!-- Submit Button -->
    <button type="submit" class="btn btn-primary" (click)="submitPlan()">Create Plan</button>
  </form>
</div>